module.exports = __webpack_public_path__ + "static/pipeline-a5232e7f5fa2e3c0a064585463f338f4.png";